var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-4"},[_c('region-selection',{attrs:{"regions":_vm.regions},on:{"regionChange":_vm.regionChange}}),(_vm.feature)?_c('sub-region-map',{attrs:{"submissions":_vm.submissions,"featureCollection":{ type: 'FeatureCollection', features: [_vm.feature] }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }